import { FileText } from 'lucide-react';
import { Button } from '@/components/ui/button';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog';

export interface ApprovalDraftPromptProps {
  open: boolean;
  onDismiss: () => void;
  onOpenDraft: () => void;
}

export function ApprovalDraftPrompt(props: ApprovalDraftPromptProps): JSX.Element {
  return (
    <Dialog
      open={props.open}
      onOpenChange={(open) => {
        if (!open) props.onDismiss();
      }}
    >
      <DialogContent>
        <DialogHeader>
          <DialogTitle>Order draft waiting for approval</DialogTitle>
          <DialogDescription>
            This order has a draft ready to review. Open the draft to approve or reject it.
          </DialogDescription>
        </DialogHeader>
        <DialogFooter>
          <Button variant="ghost" onClick={props.onDismiss}>
            Dismiss
          </Button>
          <Button onClick={props.onOpenDraft}>
            <FileText className="h-4 w-4" />
            Open draft
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
